const handlerImports = {
    dpresults_accommodation_details: () => (
        import(/* webpackChunkName: "roomSelectionHandler" */ 'od-modules/handlers/dpresults/dpresults_accommodation_details')
    ),
    dpresults_accommodation: () => (
        import(/* webpackChunkName: "dpresultsAccommodationHandler" */ 'od-modules/handlers/dpresults/dpresults_accommodation')
    ),
    dpresults_flights: () => (
        import(/* webpackChunkName: "dpresultsFlightsHandler" */ 'od-modules/handlers/dpresults/dpresults_flights')
    ),
};

module.exports = handlerImports;
